import React from 'react';
import PropTypes from 'prop-types';
import { captureMessage } from 'error_tracker';

import ApiRequest from 'core/api/request';
import { parseError } from 'core/api/utils';
import { ListingConsumer } from 'core/providers/ListingApp';
import { getAppData, getListingData } from 'core/utils/getAppData';
import { TrackUtil, HeapUtil, promiser } from 'core/utils';
import { getListingProps } from 'core/utils/Braze';

/*
 * Higher Order Component that needs to be passed a component:
 * e.g. FavoriteButtonContainer(FavoriteButton)
 */
const WithFavoriteButton = FavoriteBtn => {
	class FavoriteButtonContainer extends React.Component {
		trackEvent = (eventName, on) => {
			TrackUtil.trackEvent('favorite_button', {
				statjoy: [{
					step_name: eventName,
					cus1: on ? 'on' : 'off',
				}],
			});
			HeapUtil.track("wishlistInteraction", { action: on ? "added" : "removed" });

		}

		trackFavorite = () => {
			const listing = getListingData() || {};
			TrackUtil.trackEvent("listing_box_fav", {
				braze: [getListingProps(listing)],
				statjoy: [{ cus1: listing.listingId }]
			});
		}

		toggle = ({ likes, hasFavorited, onUpdate }) => async () => {
			const { customerId, listingId, onSuccess } = this.props;
			const nowOn = !hasFavorited;

			if (!customerId) {
				captureMessage(`Logged out favorite attempt on listing with id: ${listingId}`);
				return;
			}

			onUpdate({
				hasFavorited: nowOn,
				likes: nowOn ? (likes + 1) : (likes - 1),
			});

			const data = {
				customer_id: customerId,
				listing_id: listingId,
				method: 'listing',
			};

			const [error, res] = await promiser(ApiRequest.post("/wishlistings/", data));
			if (error) {
				const msg = parseError(error);
				captureMessage(`Favorite failed: ${msg}`);
				TrackUtil.trackEvent("favoriteButtonError", {
					fullstory: [data],
				});
				// revert state:
				onUpdate({ hasFavorited, likes });
				return;
			}

			this.trackEvent('success', nowOn);

			if (nowOn) {
				this.trackFavorite();
				onSuccess && onSuccess();
			}

			TrackUtil.identify({ force: true });
		}

		triggerLogin = () => {
			TrackUtil.trackEvent('login_prompt', {
				statjoy: [{
					step_name: 'favorite',
				}],
			});
			this.props.triggerLogin();
		}

		render() {
			const { triggerLogin, toggle } = this;
			const { customerId } = this.props;

			return (
				<ListingConsumer>
					{({ likes, hasFavorited, onUpdate }) => {
						return (
							<FavoriteBtn
								on={hasFavorited}
								likes={likes}
								onClick={customerId ? toggle({ likes, hasFavorited, onUpdate }) : triggerLogin}
							/>
						);
					}}
				</ListingConsumer>
			);
		}
	}

	FavoriteButtonContainer.propTypes = {
		listingId: PropTypes.number.isRequired,
		customerId: PropTypes.number,
		triggerLogin: PropTypes.func.isRequired,
		onSuccess: PropTypes.func,
	};
	return FavoriteButtonContainer;
};

export default WithFavoriteButton;
